import {
  AfterContentInit,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { UnifiedFlowService } from '../unified.service';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ModuleStatusService } from '../../services/module-status.service';
import { FormService } from '../../conditional-form/form-service.service';
import { CommonModule } from '@angular/common';
import { fromEvent, map, Subscription, throttleTime } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrl: './main-nav.component.scss',
  imports: [MatIconModule, MatProgressBarModule, CommonModule, MatButtonModule],
})
export class MainNavComponent
  implements OnChanges, OnInit, OnDestroy, AfterViewInit, AfterContentInit
{
  unfFlowSvc = inject(UnifiedFlowService);
  modStatusSvc = inject(ModuleStatusService);
  frmSvc = inject(FormService);

  @Input() currentStep;
  @Input() currentApp;
  @Input() navDisabled;
  @Input() profileData;
  @Input() loading;
  @Output() changeTab = new EventEmitter();
  htmlContentElement: any;
  scrollStyle: boolean;
  isNaN: (value: unknown) => boolean = Number.isNaN;
  targetElement: any;
  mutationObserver: MutationObserver;
  scrollSub: Subscription;

  ngOnInit(): void {
    this.targetElement = document.querySelector('.all-app-content');
    if (this.targetElement) {
      this.mutationObserver = new MutationObserver(x => {
        this.scrollCheck();
      });

      // Start observing the target element for changes
      this.mutationObserver.observe(this.targetElement, {
        attributes: true, // Watch for attribute changes
        childList: true, // Watch for changes in child elements
        subtree: true, // Watch for changes in descendant elements
      });

      // Add a scroll event listener
      this.scrollSub = fromEvent(window, 'scroll')
        .pipe(
          throttleTime(50),
          map(() => document.querySelector('.all-app-content').scrollHeight)
        )
        .subscribe(() => {
          this.scrollCheck(); // Check scroll state on scroll
        });
    }
  }

  ngOnDestroy(): void {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    this.scrollSub?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      this.scrollCheck();
    });
  }

  ngAfterViewInit(): void {
    this.scrollCheck();
  }

  ngAfterContentInit(): void {
    this.scrollCheck();
  }

  scrollCheck() {
    this.htmlContentElement = document.querySelector('.all-app-content');
    if (
      this.htmlContentElement?.scrollHeight - 97 <=
      window.scrollY + window.innerHeight
    ) {
      this.scrollStyle = true;
    } else {
      this.scrollStyle = false;
    }
  }

  handleTabChange(change: string): void {
    this.unfFlowSvc.setTriggerTabChange(change);
    // this.changeTab.emit(change);
  }
}
